/**
 * CB260924 サイト検索の共通部品（検索ページ sections/search.liquid とヘッダー候補 header-search.js が使う）。
 * - 索引は sections/search-index.liquid（/collections/all?section_id=search-index&page=N・250件/回）。
 *   全ページ分をつなげて sessionStorage に保存する（取得から5分以内なら通信なしで使い回す）。
 *   S40-03（10/13）: 鮮度を見ずに使い続けていたため、廃番中（アーカイブ）に作った索引が残り、戻した商品が検索に出なかった。
 *   → 取得時刻を持たせて5分で捨てる。検索ページは load({ verify: true }) で1ページ目を取り直し、
 *     総件数か先頭250件の並びが変わっていればその場で全部取り直す（ヘッダー候補は期限だけ）。
 * - 検索対象: 商品名・品番名カナ・ブランド・マテリアル・スペック（9/24 決定）。
 * - 正規化: NFKC(全半角統一)＋カタカナ→ひらがな＋小文字化＋空白・区切り記号(- ・ / . など)の除去。
 * - 検索語を空白で区切った語が**すべて**どこかの項目に含まれる商品だけを返す（AND）。
 *   並び: 商品名/カナに全語が入る商品 → ブランド込みで入る商品 → マテリアル/スペックまで使う商品。同順位は索引順。
 */
(function () {
  var CACHE_KEY = 'asplund:searchIndex:v2'; // v2 = 取得時刻(at)つき。v1 は鮮度が分からないので読まない
  var OLD_KEYS = ['asplund:searchIndex:v1'];
  var TTL_MS = 5 * 60 * 1000;
  var SEP = /[\s\-‐‑‒–—―－_・･\/／.,，、。()（）\[\]［］'"’”]+/g;

  function norm(s) {
    if (!s) return '';
    s = String(s);
    if (s.normalize) s = s.normalize('NFKC');
    s = s.replace(/[ァ-ヶ]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0x60); });
    return s.toLowerCase().replace(SEP, '');
  }
  function tokens(q) {
    var s = String(q || '');
    if (s.normalize) s = s.normalize('NFKC');
    return s.split(/\s+/).map(norm).filter(Boolean);
  }

  function fetchPage(p) {
    var url = '/collections/all?section_id=search-index&page=' + p;
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status + ' search-index p' + p);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var s = doc.querySelector('[data-search-index]');
      if (!s) throw new Error('search index not found');
      return { pages: Number(s.dataset.pages) || 1, total: Number(s.dataset.items) || 0, items: JSON.parse(s.textContent) };
    });
  }

  function prepare(items) {
    items.forEach(function (it, n) {
      it.n = n; // 索引順位（0始まり）＝/collections/all の既定の並び
      it._t = norm(it.t) + '\u0001' + norm(it.k);
      it._b = norm(it.b);
      it._r = norm(it.m) + '\u0001' + norm(it.s);
    });
    return items;
  }

  function readCache() {
    try {
      OLD_KEYS.forEach(function (k) { sessionStorage.removeItem(k); });
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      var age = c && Date.now() - c.at;
      if (c && Array.isArray(c.items) && c.items.length && c.items.length === c.total && age >= 0 && age < TTL_MS) return c;
    } catch (e) { /* 壊れたキャッシュ・ストレージ不可は取り直す */ }
    return null;
  }
  function writeCache(items) {
    try {
      var slim = items.map(function (it) { return { id: it.id, h: it.h, t: it.t, k: it.k, b: it.b, m: it.m, s: it.s, i: it.i }; });
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), total: items.length, items: slim }));
    } catch (e) { /* 容量超過等は無視 */ }
  }
  function clear() {
    loading = null;
    try { sessionStorage.removeItem(CACHE_KEY); } catch (e) { /* ストレージ不可は無視 */ }
  }
  // キャッシュが今の1ページ目と食い違っていないか（総件数＋先頭ページの商品IDの並び）
  function sameAsFirst(c, first) {
    if (c.total !== first.total) return false;
    for (var i = 0; i < first.items.length; i++) {
      if (!c.items[i] || String(c.items[i].id) !== String(first.items[i].id)) return false;
    }
    return true;
  }
  // 1ページ目でページ数を知り、残りは並列に取る
  function fetchRest(first) {
    var rest = [];
    for (var p = 2; p <= Math.min(first.pages, 20); p++) rest.push(fetchPage(p));
    return Promise.all(rest).then(function (rs) {
      var items = first.items.concat.apply(first.items, rs.map(function (r) { return r.items; }));
      if (items.length !== first.total) throw new Error('search index size mismatch ' + items.length + '/' + first.total);
      writeCache(items);
      return prepare(items);
    });
  }

  var loading = null;
  // opts.verify: キャッシュが期限内でも1ページ目を取り直して照合する（検索ページ用）
  // opts.fresh : キャッシュを使わず全部取り直す（cards missing 時の再取得用）
  function load(opts) {
    opts = opts || {};
    if (loading && !opts.verify && !opts.fresh) return loading;
    var c = opts.fresh ? null : readCache();
    var p;
    if (c && !opts.verify) p = Promise.resolve(prepare(c.items));
    else p = fetchPage(1).then(function (first) {
      if (c && sameAsFirst(c, first)) return prepare(c.items);
      return fetchRest(first);
    });
    loading = p;
    p.catch(function () { if (loading === p) loading = null; }); // 失敗したら次回は取り直す
    return p;
  }

  function search(q, items) {
    var ts = tokens(q);
    if (!ts.length) return [];
    var hits = [];
    items.forEach(function (it) {
      var all = it._t + '\u0001' + it._b + '\u0001' + it._r;
      for (var i = 0; i < ts.length; i++) { if (all.indexOf(ts[i]) < 0) return; }
      var rank = 2;
      if (ts.every(function (t) { return it._t.indexOf(t) >= 0; })) rank = 0;
      else if (ts.every(function (t) { return (it._t + '\u0001' + it._b).indexOf(t) >= 0; })) rank = 1;
      hits.push({ it: it, rank: rank });
    });
    hits.sort(function (a, b) { return (a.rank - b.rank) || (a.it.n - b.it.n); });
    return hits.map(function (h) { return h.it; });
  }

  window.AsplundSearchIndex = { load: load, clear: clear, search: search, normalize: norm };
})();
